module.exports = __webpack_public_path__ + "img/banner1.1923bae6.png";